<p class="text-muted">
    redirection...
</p>